<!-- 
Levy calculator playground subheading
-->
<template>
  <h3 class="title">
    <slot/>
    <v-tooltip v-if="help" bottom max-width="500">
      <v-icon slot="activator" color="info" class="ml-2" style="cursor:pointer">info</v-icon>
      <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component vue/no-v-html -->
      <span v-html="help"/>
    </v-tooltip>
  </h3>
</template>

<script>
export default {
  props: {
    help: {
      validator: prop => typeof prop === "string" || prop == null,
      default: null
    }
  }
};
</script>
